const header = {
  // all the properties are optional - can be left empty or deleted
  // homepage: 'https://aniruddhadhadge.tech',
  // title: 'Aniruddha',
}

const about = {
  // all the properties are optional - can be left empty or deleted
  name: 'Aniruddha Dhadge',
  role: 'Java Backend Developer',
  description:
    'Adipisicing sit fugit ullam unde aliquid sequi Facilis soluta facilis perspiciatis corporis nulla aspernatur. Autem eligendi rerum delectus modi quisquam? Illo ut quasi nemo ipsa cumque perspiciatis! Maiores minima consectetur.',
  resume: 'https://example.com',
  social: {
    linkedin: 'https://www.linkedin.com/in/abdhadge/',
    github: 'http://github.com/abdhadge/',
  },
}

const projects = [
  // projects can be added an removed
  // if there are no projects, Projects section won't show up
  {
    name: 'Quora App Clone',
    description: 'Quora-like Q&A platform with layered architecture and pagination.',
    stack: ['Java', 'Spring Boot', 'MySQL'],
    // sourceCode: 'https://github.com',
    // livePreview: 'https://jigyasa.imcc.mespune.in',
  },
  {
    name: 'Hospital Management System',
    description: 'Healthcare backend enabling patient, doctor, appointment, and billing workflows.',
    stack: ['Java', 'Spring Boot', 'MySQL'],
    // sourceCode: 'https://github.com',
    // livePreview: 'https://theprasang.com',
  }

]

const skills = [
  // skills can be added or removed
  // if there are no skills, Skills section won't show up
  'Java',
  'JavaScript',
  'SQL',
  'Spring Boot',
  'React',
  'Restful API',
  'MySQL',
  'MongoDB',
  'Firebase',
  'JIRA',
  'Docker',

]

const contact = {
  // email is optional - if left empty Contact section won't show up
  email: 'abdhadge@gmail.com',
}

export { header, about, projects, skills, contact }
